import {FC} from 'react'

import {Text} from '@/components/common/content/Text'
import {SuccessModal} from '@/components/common/success/SuccessModal'
import {useAuthContent} from '@/content/user/authentication'
import {Trans, useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'

type AccountActivationModalProps = {
  email: string
  closeModal: () => void
  isVisible: boolean
}

export const AccountActivationModal: FC<AccountActivationModalProps> = ({
  email,
  closeModal,
  isVisible,
}) => {
  const {t} = useTranslation()
  const {title, descriptionLine1, descriptionLine2} = useAuthContent().accountActivation
  const textColor = theme.palette.text.light

  return (
    <SuccessModal
      isVisible={isVisible}
      title={t(title)}
      description={
        <>
          <Text align="center" color={textColor} className="wrap-anywhere">
            <Trans i18nKey={descriptionLine1} values={{email}} />
          </Text>
          <Text align="center" color={textColor}>
            <Trans i18nKey={descriptionLine2} />
          </Text>
        </>
      }
      hasEmailClients={true}
      hasSpamDescription={true}
      onClose={closeModal}
      maxContentWidth="600px"
    />
  )
}
